export enum ServiceNames {
    ServiceModel = "ServiceModel",
    UserService = "UserService",
    // i. e. AnotherService = "AnotherService",
  }